<style scoped>
.map-fields-name-action sup {
  color: #ff0000;
  font-size: 14px !important;
}

.map-fields-name-action-input sup {
  color: #ff0000;
  font-size: 14px !important;
}

.action-tab-select-down {
  text-align: left;
}

.workflow-map-fields {
  width: 100% !important;
}

.map-fields-name {
  width: 100% !important;
}

.action-dropdown-toggle {
  background: none;
  border: none;
  font-weight: 400;
  color: #00a8ff;
  padding: 2px;
  font-size: 12px;
}

.map-fields-name-action {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
}

.map-fields-name-action-input {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
  margin-top: 16px;
}

.workflow-map-fields-items a:after {
  content: none;
}

.action-tab-select-down-menu ul li a {
  margin-left: 0;
  padding-left: 10px;
}

.action-tab-select-down-menu {
  width: 200px;
}

.action-dropdown-toggle::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-left: 5px;
}

.wf-task-tab-content a:after {
  content: none;
}

.send-mail-inputs {
  margin-top: 0;
  height: auto;
  padding: 2px 0px;
  width: 100% !important;
}

.workflow-tab-select-table {
  text-align: left !important;
  padding: 0 25px;
  margin-left: 16.5%;
}

.workflow-crete-set-field {
  margin-top: 0 !important;
}

.workflow-accordion-container-modify {
  overflow-y: scroll;
  padding: 0 14px 10px 14px;
  position: relative;
  height: 600px;
}

.popup-container {
  min-height: 300px;
  margin-top: 0.75em !important;
  position: absolute !important;
}

#modify-record {
  height: 100%;
}

#automated-section .full-width-dialog {
  min-width: 60% !important;
  height: 92vh;
}

#automated-section .workflow-map-fields-container {
  padding: 25px;
  height: calc(100% - 237px);
  overflow-y: auto;
}

.reset-btn {
    display: flex;
    padding-top: 1em;
    padding-left: 0.5em;
}

</style>
<template>
  <!-- Modal -->
  <div class="modal fade automation_action_modal_main" id="modify-record-modal" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg-custom full-width-dialog" role="document">
      <div class="modal-content automation_action_modal_content">
        <div class="modal-body workflow-modal-body">
          <div class="tab-pane fade show active" id="modify-record" role="tabpanel" aria-labelledby="modify-record-tab">
            <div class="border-body-right-top"></div>
            <div class="workflow-modify-modal-header">
              <h2>{{ lang.modify_record }}</h2>
            </div>
            <div class="workflow-tab-content">
              <div class="workflow-crete-set-field">
                <h2>{{ lang.hint_one_modify_record }}</h2>
                <p>{{ lang.hint_two }}</p>
              </div>
            </div>
            <div class="workflow-tab-select-table">
              <p>{{ lang.table }}</p>
              <div class="dropdown workflow-tab-select-down">
                <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ GetSelectedTableLabel() }}
                </button>
                <div class="dropdown-menu workflow-tab-select-down-menu" aria-labelledby="dropdownMenuButton">
                  <div class="popup-search-filter">
                    <input class="form-control table-filter-row-search" id="search-keyword" type="Search"
                           :placeholder="lang.search+'..'">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </div>
                  <div class="popup-search-filter-items">
                    <p>{{ lang.select + ' ' + lang.table }}</p>
                    <ul>
                      <li><a href="javascript:void(0)">{{ GetSelectedTableLabel() }}</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="workflow-map-fields-container">
              <p class="workflow-map-fields-title">{{ lang.map_fields }}</p>
              <div class="workflow-map-fields">
                <div v-for="field in GetSelectedTableFields()" v-if="field.field_type != 'autonumber'" :key="field.id"
                     class="workflow-map-fields-items">
                  <div class="row">
                      <div class="col-md-3 d-flex justify-content-end" :class="fieldTypeOf(field) ? 'align-items-center' : ''">
                      <div class="map-fields-name-action">
                        {{ field.label }} <sup v-if="field.is_required">*</sup>
                      </div>
                    </div>
                    <div class="col-auto d-flex align-items-center">
                      <div class="dropdown action-tab-select-down d-flex align-items-center" v-if="fieldTypeOf(field)">
                        <input class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                               v-bind:class="{ 'is-invalid-popup': modify_record_error[field.name] == true  }"
                               v-bind:id="'mapFieldModifyDD-'+field.id" type="button"
                               v-on:click.stop.prevent="modifyAccordion(field.label)"
                               v-bind:value="selectedValues[field.id]"
                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                        <div class="popup-container-main" v-if="checkActiveDD(field.label)"
                             :id="'popup-container-main-'+level">
                          <div class="popup-container popup-container-modify">
                            <div class="popup-search-filter">
                              <div class="workflow-selected-field">
                                <span>{{ lang.select + ' ' + lang.value }}</span>
                              </div>
                            </div>
                            <div class="workflow-accordion-container-modify" v-click-outside="outside">
                              <AccordionForModifyRecord
                                  :level="0"
                                  :table="SelectedTable.label"
                                  :fields="SelectedTable.fields"
                                  :users="UserTable"
                                  :lang="lang"
                                  :mapping_for="field"
                                  :custom="true"
                                  :field_type="field.field_type"
                                  v-on:ModifyRecordOptionSelectedEvent="ModifyRecordOptionSelected"
                                  :ModifyRecordMapping="ModifyRecordMapping"
                                  :executeHandler="executeHandler"
                              ></AccordionForModifyRecord>
                            </div>
                          </div>
                        </div>
                          <div class="reset-btn">
                            <button
                              class="close close-custom"
                              v-if="hasSelectedData(ModifyRecordMapping,field) && fieldTypeOf(field)"
                              @click="removeSelectedItem(ModifyRecordMapping,field)"
                            >
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                      </div>

                      <div v-else>
                        <dateTimePickerModifyRecord
                            :level="level"
                            :mapping_for="field"
                            :custom="true"
                            :lang="lang"
                            :field_type="field.field_type"
                            :Auth="Auth"
                            :actionType="'modify_record'"
                            :type="field.type"
                            v-on:ModifyRecordOptionSelectedEvent="ModifyRecordOptionSelected"
                            v-on:removeSelectedItemEvent="removeSelectedItem(ModifyRecordMapping, field)"
                            :ModifyRecordMapping="ModifyRecordMapping"
                            v-bind:class="{ 'is-invalid-popup': modify_record_error[field.name] == true  }"
                        ></dateTimePickerModifyRecord>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default wf-modal-cancel" data-dismiss="modal">{{ lang.cancel }}</button>
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="SaveAction()">{{ lang.save }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dateTimePickerModifyRecord from './dateTimePickerModifyRecord.vue';

export default {
  name: 'CreateRecordModal',
  props: [
    'SelectedTableId',
    'whenshould',
    'entity_id',
    'url',
    'level',
    'Auth',
    'lang',
    'SelectedTableExcludedColumnList',
  ],
  components: {
    // Pixel
  },
  data() {
    return {
      SelectedTable: {},
      selectedValues: [],
      UserTable: [],
      executeHandler: null,
      data_status: null,
      // fields for mapping the values
      MapFieldsModify: null,
      ExceptionFieldType: ['date', 'datetime', 'dateDynamic', 'datetimeDynamic'],
      //Mapping Data

      SaveModifyRecord: [],
      ActiveAccordion: [],
      ModifyRecordMapping: [],
      Data: [],

      modify_record: null,
      modify_record_error: null,
    }
  },
  mounted() {
    this.GetContactTableData();
  },
  watch: {
    whenshould() {
      this.executeHandler = this.whenshould;
    }
  },
  methods: {

    hasSelectedData(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        return true;
      }

      return false;
    },
    removeSelectedItem(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        mappingData.splice(_index, 1);
      }

      if (this.modify_record) {
        for (let x in this.modify_record) {
          if (x == field.name) {
            this.modify_record[x].value = null;
          }
        }
      }
      this.buildSelectedLabels();
    },
    LoadDefaults(action_id, _data, data_status) {

      // Get saved data from db for edit action modal
      if (status != null) {
        this.data_status = data_status;
      } else {
        this.data_status = null;
      }

      if (_data == null) {
        // Get saved data from db for edit action modal
        axios.post('/get-data-for-edit-modal', {'action_id': action_id}).then(response => {
          if (response.data.success) {
            this.SelectedTable = response.data.result.action_map.modify_record.selected_table;
            this.ModifyRecordMapping = response.data.result.action_map.modify_record.mapping_data;
            this.buildSelectedLabels();
            this.GenerateDynamicModify();
          }

        });
      } else {

        this.SelectedTable = _data.modify_record.selected_table;
        this.ModifyRecordMapping = _data.modify_record.mapping_data;

        this.Data = _data;
        this.buildSelectedLabels();
        this.GenerateDynamicModify();
      }


    },
    GenerateDynamicModify() {
      if (this.SelectedTable) {
        if (this.SelectedTable.fields) {
          let modify_record = {};
          for (let x in this.SelectedTable.fields) {
            if (this.ModifyRecordMapping) {

              if(this.SelectedTable.fields[x]){
                let _index = this.ModifyRecordMapping.findIndex(y => y.mapping_for_name == this.SelectedTable.fields[x].name);

                if (_index > -1) {
                  modify_record[this.SelectedTable.fields[x].name] = {
                    value: this.ModifyRecordMapping[_index].mapped_with_name,
                  };
                } else {
                  modify_record[this.SelectedTable.fields[x].name] = {
                    value: null,
                  };
                }
              }

            }
          }
          this.modify_record = modify_record;

          let modify_record_error = {};
          for (let x in this.SelectedTable.fields) {
            if(this.SelectedTable.fields[x]){
              modify_record_error[this.SelectedTable.fields[x].name] = false;
            }
          }
          this.modify_record_error = modify_record_error;
        }

      }

    },
    GetContactTableData() {
      axios.post('/contact-table-data').then(response => {
        if (response.data.success) {
          this.UserTable = response.data.result;
        }
      });
    },
    modifyAccordion(label) {
      var _index = this.ActiveAccordion.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordion = [];
        this.ActiveAccordion.push(label);
      } else {
        this.ActiveAccordion = [];
      }
    },
    checkActiveDD(field) {
      var _index = this.ActiveAccordion.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    outside() {
      this.ActiveAccordion = [];
    },
    ModifyRecordOptionSelected(data) {
      // remove the old value if exists

      if (
        data.mapping_for.field_type === 'multiselect' ||
        data.mapping_for.field_type === 'multipleselect' ||
        (data.selected_field && data.selected_field.field_type_dd && data.selected_field.field_type_dd === 'multiselect')
      ) {
        this.ManipulationMultiSelectModifyRecord(this.ModifyRecordMapping, data);
        this.buildSelectedLabels()
        return;
      } else {
        let _index = this.ModifyRecordMapping.findIndex(x =>
          x.mapping_for_id == data.mapping_for.id
        );
        if (_index > -1) {
          this.ModifyRecordMapping.splice(_index, 1);
        }
      }

      let field_type_dd = null;

      if (data.selected_field.field_type_dd != undefined) {
        field_type_dd = data.selected_field.field_type_dd;
      }

      for (let x in this.modify_record) {
        if (x == data.mapping_for.name) {
          this.modify_record[x].value = data.selected_field.name;
        }
      }

      if (data.selected_field.name !== undefined) {
        this.ModifyRecordMapping.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: data.selected_field.id,
          mapped_with_name: data.selected_field.name,
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }

      if (data.record_type == 'old') {
        $('#mapFieldModifyDD-' + data.mapping_for.id).val('Old Record.' + data.selected_field.label);
      } else {
        $('#mapFieldModifyDD-' + data.mapping_for.id).val(data.selected_field.label);
      }

      if (data.mapping_for.field_type == 'multiselect') {
        return;
      }

      this.ActiveAccordion = [];
      this.buildSelectedLabels()
    },
    buildSelectedLabels(fields = null) {
      if (!fields) {
        fields = this.SelectedTable.fields;
      }
      fields.map((field) => {
        this.selectedValues[field.id] = this.InitLabel(field);
      });
      this.$forceUpdate();
    },
    InitLabel(field) {
      let _index = this.ModifyRecordMapping.findIndex(x => x.mapping_for_id == field.id);
      if (_index > -1) {
        let _selected_field_index = this.SelectedTable.fields.findIndex(x => x.id == this.ModifyRecordMapping[_index].mapped_with_id);

        if (this.ModifyRecordMapping[_index].record_type == "new") {
          return this.SelectedTable.fields[_selected_field_index].label;
        } else if (this.ModifyRecordMapping[_index].record_type == "old") {
          return this.lang.old + ' ' + this.lang.record + '.' + this.SelectedTable.fields[_selected_field_index].label;
        } else if (this.ModifyRecordMapping[_index].record_type == "custom") {

          if (Array.isArray(this.ModifyRecordMapping[_index].mapped_with_name)) {

            let val = '';
            for (let i = 0; i < this.ModifyRecordMapping[_index].mapped_with_name.length; i++) {
              val += this.ModifyRecordMapping[_index].mapped_with_name[i] + ',';
            }

            return val.replace(/,\s*$/, '');
          } else {
            return this.SelectedTable.fields[_selected_field_index] = this.ModifyRecordMapping[_index].mapped_with_name;
          }
        } else if (this.ModifyRecordMapping[_index].record_type === "user") {
          if (Array.isArray(this.ModifyRecordMapping[_index].mapped_with_name)) {
            let val = '';
            for (let i = 0; i < this.ModifyRecordMapping[_index].mapped_with_name.length; i++) {
              val += this.ModifyRecordMapping[_index].mapped_with_name[i] + ',';
            }
            return this.SelectedTable.fields[_selected_field_index] = val.replace(/,\s*$/, '');
          } else {
            return this.SelectedTable.fields[_selected_field_index] = this.ModifyRecordMapping[_index].mapped_with_name;
          }
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }

      } else {
        return this.lang.select + ' ' + this.lang.value;
      }
    },
    SaveAction() {
      let modify_flag = 0;

      for (let error in this.modify_record) {
        this.modify_record_error[error] = false;
      }

      if ((modify_flag == 0)) {
        for (let error in this.modify_record) {
          this.modify_record_error[error] = false;
        }
        this.SaveActionAfterValidation();
      }
    },
    SaveActionAfterValidation() {
      let data = {};

      if (this.data_status == "saved") {

        for (let x in this.ModifyRecordMapping) {
          if (this.ModifyRecordMapping[x].field_type_dd == "datetime" ||
              this.ModifyRecordMapping[x].field_type_dd == "date") {
            this.ModifyRecordMapping[x]['isEdit'] = true;
          }
        }

        data = {
          action_id: this.entity_id,
          modify_record: {
            modify_record: {
              selected_table: this.SelectedTable,
              mapping_data: this.ModifyRecordMapping,
            },
            level: this.Data.level
          }
        };
      } else {
        data = {
          action_id: null,
          modify_record: {
            modify_record: {
              selected_table: this.SelectedTable,
              mapping_data: this.ModifyRecordMapping,
            },
            level: this.Data.modify_record.level
          }
        };
      }

      $('#modify-record-modal').modal('hide');

      this.$emit('UpdateModifyRecordActionEvent', data);
    },
    requiredFieldToScroll(divClass, action, field_label) {

      // this.$awn.alert(this.lang.required+' '+field_label+' '+this.lang.field_not_set,{
      //     labels : {
      //       alert: this.lang.failed,
      //     }
      // });

      toastr.error(this.lang.required + ' ' + field_label + ' ' + this.lang.field_not_set, this.lang.failed);

      var focusOnDiv = document.querySelector('#modify-record-modal .modal-body .workflow-map-fields-container .' + action + '-record-' + divClass);

      focusOnDiv.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    },
    containsKey(obj, key) {
      var isExist;
      isExist = Object.keys(obj).includes(key);
      if (isExist) {
        if (obj[key]) {
          return obj[key];
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      }
    },
    GetSelectedTableLabel() {
      if (this.SelectedTable != undefined) {
        return this.SelectedTable.label;
      } else {
        return this.lang.select + ' ' + this.lang.table;
      }
    },
    GetSelectedTableFields() {
      if (this.SelectedTable != undefined) {
        return this.SelectedTable.fields;
      } else {
        return [];
      }
    },
    fieldTypeOf(FieldType) {

      let isIncludeSelctedField = this.ExceptionFieldType.includes(FieldType.type);

      if (isIncludeSelctedField) {
        return false;
      }

      return true;
    },
    ManipulationMultiSelectModifyRecord(ModifyRecord, data) {

      let outer_index = ModifyRecord.findIndex(x =>
          x.mapping_for_id == data.mapping_for.id
      );

      if (outer_index > -1) {

        let inner_index = ModifyRecord[outer_index].mapped_with_name.indexOf(data.selected_field.name);

        if (inner_index > -1) {
          ModifyRecord[outer_index].mapped_with_name.splice(inner_index, 1);
          ModifyRecord[outer_index].mapped_with_id.splice(inner_index, 1);

          if (ModifyRecord[outer_index].mapped_with_name.length == 0) {
            ModifyRecord.splice(outer_index, 1);
          }

        } else {
          ModifyRecord[outer_index].mapped_with_name.push(data.selected_field.name);
          ModifyRecord[outer_index].mapped_with_id.push(data.selected_field.id);
        }

      } else {

        let field_type_dd = null;

        if (data.selected_field.field_type_dd != undefined) {
          field_type_dd = data.selected_field.field_type_dd;
        }

        ModifyRecord.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: [data.selected_field.id],
          mapped_with_name: [data.selected_field.name],
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }
    }
  }

}
</script>
